<template>
    <b-container class="atmo-nested-section p-2">
        <text-header margin-class="mb-3">Создание дополнительного соглашения</text-header>
        <b-overlay :show="isDataSending" opacity="0.6" rounded spinner-variant="primary">
            <text-row-proposal-specification-table v-model="purchase.supplier_proposal.deliverables" :without-vat="purchase.supplier_proposal.without_vat">
                <template #header>
                    <h5 class="grey-color ml-1 mb-1 main_text font-weight-bold">Спецификация контракта</h5>
                </template>
            </text-row-proposal-specification-table>
            <text-row-price v-model="purchase.purchase_terms.contract_price" label="Стоимость контракта" compact :label-cols-lg="4" />
            <form-row-edit-price v-model="form.price" :v="$v.form.price" label="Стоимость контракта с учетом дополнительного соглашения" :label-cols-lg="4" />
            <form-row-edit-date label="Дата заключения дополнительного соглашения" v-model="form.conclusion_date" :v="$v.form.conclusion_date" :min-date="purchase.contract.contract_conclusion_date" :max-date="$now()" :label-cols-lg="4" />
            <form-row-single-line-document-upload v-model="form.attachment" :v="$v.form.attachment" title="Дополнительное соглашение" :label-cols-lg="4" />
        </b-overlay>
        <b-overlay :show="isDataSending" class="d-inline-block" opacity="0.6" rounded spinner-small spinner-variant="primary">
            <b-button variant="custom-outline-secondary" class="text-uppercase mt-1 mr-3" @click="$emit('cancel')">Отмена</b-button>
            <b-button variant="custom-green" class="text-uppercase mt-1" :disabled="$v.$invalid" @click="sendSupplementaryAgreement">Отправить дополнительное соглашение поставщику</b-button>
        </b-overlay>
    </b-container>
</template>

<script>
import { maxValue, minValue, required } from 'vuelidate/lib/validators';
import TextRowProposalSpecificationTable from '@/components/proposals/partials/text-row-proposal-specification-table.vue';

export default {
    name: 'fl44-unknown-volume-create-supplementary-agreement',
    components: { TextRowProposalSpecificationTable },
    props: {
        purchase: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            isDataSending: false,
            form: {
                conclusion_date: null,
                price: 0,
                attachment: null,
                type: 'regular'
            },
            priceLimit: 0
        };
    },
    validations() {
        const contractPrice = this.purchase.purchase_terms.contract_price;
        const maxPrice = this.purchase.purchase_terms.order_type.price_limit;
        return {
            form: {
                conclusion_date: {
                    required
                },
                attachment: {
                    required
                },
                price: {
                    required,
                    minValue: minValue(contractPrice - contractPrice * 0.1),
                    maxValue: maxValue(Math.min(contractPrice + contractPrice * 0.1, maxPrice))
                }
            }
        };
    },
    mounted() {
        this.fillData();
    },
    methods: {
        fillData() {
            this.form.price = this.purchase.contract.actual_contract_price;
        },
        async sendSupplementaryAgreement() {
            this.isDataSending = true;
            await this.$api.products.fl44UnknownVolume.supplementaryAgreements
                .store(this.purchase.id, this.purchase.contract.id, this.form)
                .then((response) => {
                    if (response) {
                        this.$emit('done');
                    }
                })
                .catch(() => {})
                .finally(() => {
                    this.isDataSending = false;
                });
        }
    }
};
</script>
